import { createSelector } from 'reselect'

const affinityGroupSelector = (state, props) =>
  state.getIn(['feature', 'affinityGroups', props.id])

const makeAffinityGroupSelector = () =>
  createSelector(affinityGroupSelector, (affinityGroup) => {
    const affinityGroupNumber =
      affinityGroup && affinityGroup.get('groupNumber')
    const highlightAffinity = affinityGroup && affinityGroup.get('on')
    return { affinityGroupNumber, highlightAffinity }
  })

export { makeAffinityGroupSelector }
